var formatNumber = function(price, length) {
  return parseFloat(price).toFixed(length);
};

export default formatNumber;
